import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Homepage } from 'pages/homepage/Homepage'

export const Route = createFileRoute('/home/{-$siteID}')({
  component: HomeRouteComponent,
  staticData: {
    title: 'Home',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})

function HomeRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <Homepage />
}
